import React from 'react';
import Typography from '@material-ui/core/Typography';

import {withTranslation} from 'react-i18next';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
  outer: {
    overflow: "hidden",
    position: 'relative',
    height: 50,
  },
  odd: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #eeeeee',
  },
  even: {},
  fieldName: {
    marginTop: 14,
    marginLeft: 4,
    fontSize: '0.9rem',
  },
  result: {
    position: 'absolute',
    right: 5,
    top: 5,
    paddingLeft: 5,
    paddingRight: 5,
    color: 'white',
    height: 40,
  },
  resultText: {
    marginTop: 9,
  },
});

const PupilField = ({index, field, t, classes}) => (
  <div className={`pupil-field ${classes.outer} ${
     isMobileApp && index % 2 > 0
       ? classes.odd : (
         !isMobileApp && Math.ceil(index/2) % 2 > 0
           ? classes.odd
           : classes.even
       )
   }`}
  >
    <Typography className={classes.fieldName}>
      {field.name}
    </Typography>
    <div className={classes.result} style={{background: field.graphic}}>
      <Typography className={classes.resultText}>
        {field.value}
      </Typography>
    </div>
  </div>
);

export default withStyles(styles)(withTranslation()(PupilField));
